module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_count_rank/5_c8c3636ffeebf572bac11bb3aeb7db3f.png";